// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carrierProgressbar {
  background: #fff8e0;
  border-radius: 4px;
  padding: 15px 17px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.carrierProgressbar--label {
  font-size: 14px;
  color: #222222;
  font-weight: 600;
  margin-right: 11px;
  white-space: nowrap;
}
.carrierProgressbar--toolTipIcon {
  display: flex;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  border: 1.5px solid #222222;
  color: #222222;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  cursor: pointer;
  margin-right: 10px;
}
.carrierProgressbar--count {
  font-size: 14px;
  font-weight: 700;
  color: #222;
  margin-right: 15px;
}
.carrierProgressbar--bar {
  width: 350px;
  height: 8px;
  border-radius: 4px;
  background: #c9b681;
  width: calc(100% - 60px);
}
.carrierProgressbar--progress {
  height: 8px;
  border-radius: 4px;
  background: #e0a504;
}
.carrierProgressbar--toolTip {
  position: relative;
}
.carrierProgressbar--toolTip:hover .carrierProgressbar--toolTipContent,
.carrierProgressbar--toolTip:hover .carrierProgressbar--toolTipArrow {
  display: block;
}
.carrierProgressbar--toolTipContent {
  background: #3c3838;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  padding: 7px 10px;
  position: absolute;
  left: 50%;
  top: -35px;
  width: 315px;
  transform: translateX(-50%);
  text-align: center;
  display: none;
}
.carrierProgressbar--toolTipArrow {
  content: '';
  border-top: 5px solid #3c3838;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  left: 3px;
  top: -9px;
  display: none;
}
.carrierProgressbar--labelToolTip {
  width: 30%;
  display: flex;
  align-items: center;
}
.carrierProgressbar--progressCount {
  width: 70%;
  display: flex;
  justify-content: right;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/carrierOnboard/carrierProgressBar/carrierProgressBar.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".carrierProgressbar {\n  background: #fff8e0;\n  border-radius: 4px;\n  padding: 15px 17px;\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n}\n.carrierProgressbar--label {\n  font-size: 14px;\n  color: #222222;\n  font-weight: 600;\n  margin-right: 11px;\n  white-space: nowrap;\n}\n.carrierProgressbar--toolTipIcon {\n  display: flex;\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  border: 1.5px solid #222222;\n  color: #222222;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  cursor: pointer;\n  margin-right: 10px;\n}\n.carrierProgressbar--count {\n  font-size: 14px;\n  font-weight: 700;\n  color: #222;\n  margin-right: 15px;\n}\n.carrierProgressbar--bar {\n  width: 350px;\n  height: 8px;\n  border-radius: 4px;\n  background: #c9b681;\n  width: calc(100% - 60px);\n}\n.carrierProgressbar--progress {\n  height: 8px;\n  border-radius: 4px;\n  background: #e0a504;\n}\n.carrierProgressbar--toolTip {\n  position: relative;\n}\n.carrierProgressbar--toolTip:hover .carrierProgressbar--toolTipContent,\n.carrierProgressbar--toolTip:hover .carrierProgressbar--toolTipArrow {\n  display: block;\n}\n.carrierProgressbar--toolTipContent {\n  background: #3c3838;\n  color: #fff;\n  font-size: 12px;\n  border-radius: 4px;\n  padding: 7px 10px;\n  position: absolute;\n  left: 50%;\n  top: -35px;\n  width: 315px;\n  transform: translateX(-50%);\n  text-align: center;\n  display: none;\n}\n.carrierProgressbar--toolTipArrow {\n  content: '';\n  border-top: 5px solid #3c3838;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  position: absolute;\n  left: 3px;\n  top: -9px;\n  display: none;\n}\n.carrierProgressbar--labelToolTip {\n  width: 30%;\n  display: flex;\n  align-items: center;\n}\n.carrierProgressbar--progressCount {\n  width: 70%;\n  display: flex;\n  justify-content: right;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
